import md5 from 'js-md5';

export function encrypt(val) {
    console.log('val',val);
    if (val==="" || val===0 || typeof val === 'undefined') {
        
        return '';
    }
    return md5(val+'warren');
}